// MVP feature flags — set to true when a feature is ready to ship post-MVP.
// All hidden code, state, handlers, and i18n keys are fully implemented;
// only the UI rendering is suppressed while the flag is false.
export const FEATURES = {
  /** Per-Agent model selector on the DNA tab. Model is inherited from Global Settings default. */
  agentModelSelector: false,
  /** Version badge in the Agent editor header. */
  agentVersionBadge: false,
  /** Action Controls card on the Guardrails tab (Approvals, Permissions, Limits). */
  guardrailsActionControls: false,
  /** Response language / Formatting section in the Guardrails Response Controls card. */
  guardrailsResponseLanguage: false,
  /** General tab in Global Settings (subscription management). */
  globalSettingsGeneral: false,
  /** Models tab in Global Settings. */
  globalSettingsModels: false,
  /** Global Settings → Connections full configuration UI (legacy). Preview card shown instead per MS-598 AC8. */
  globalConnectionsConfig: false,
  /** Global Settings → Skills full configuration UI (legacy). Preview card shown instead per MS-866 AC1. */
  globalSkillsConfig: false,
  /** Global Settings → Knowledge Base full configuration UI (legacy). Preview card shown instead per MS-866 AC1. */
  globalKnowledgeConfig: false,
  /** Global Settings → Guardrails full configuration UI (legacy). Preview card shown instead per MS-866 AC1. */
  globalGuardrailsConfig: false,
  /** Agent Interactions tab on the Audit Log page. Deferred post-MVP per MS-598 AC21. */
  auditLogInteractionsTab: false,
  /** Incident Snapshot export button on the Audit Log page. Deferred post-MVP per MS-598 AC22. */
  auditLogIncidentSnapshot: false,
} as const
